var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'iqos': true,
  'iqos-warning': !!_vm.warning
}},[(!_vm.hideTitle)?_c('h3',{class:{
   'title-box': true,
   'title-box-warning': !!_vm.warning
  }},[_vm._t("header",[(_vm.warning)?_c('img',{staticClass:"iqos-header-warning-icon",attrs:{"src":"/icons/iqos-header-warning-icon.svg"}}):_vm._e(),_vm._v(_vm._s(_vm.title)),(_vm.warning)?_c('span',[(_vm.warning !== true)?_c('span',{staticClass:"iqos-integration-warning-label"},[_vm._v(_vm._s(_vm.warning))]):_vm._e()]):_vm._e()])],2):_vm._e(),_c('div',{class:_vm.dynamicClass,attrs:{"readonly":_vm.readonly}},[_vm._t("default")],2),_vm._t("ordersTable")],2)}
var staticRenderFns = []

export { render, staticRenderFns }